<template>
  <v-dialog v-model="open_modal" width="500" scrollable>
      <v-card>
        <v-card-title class="headline">Delete device</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <p>Are you sure to eliminate the selected device?</p>
          <p>
            Name: <strong>{{ itemDelete.name }}</strong> <br>
            Token: <strong>{{ itemDelete.token }}</strong>
          </p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="closeModal">NO</v-btn>
          <v-btn color="red" @click="deleteDevice">YES</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    itemDelete: {
      type: Object,
      required: true,
    }
  },
  data () {
    return {
      open_modal: true,
    };
  },
  computed: {
    
  },
  methods: {
    closeModal () {
      this.$emit('closeModal');
    },
    deleteDevice () {
      this.$emit('deleteDevice', this.itemDelete.index);
      const url = `/devices/${this.itemDelete.id}`;
      window.axios.delete(url).then(response => {
        this.$store.dispatch('setLoading', false);
        this.$emit('closeModal');
        this.$store.dispatch('setSnackbar', {
          show: true,
          color: 'success',
          text: 'Device removed correctly.'
        });
      });
    }
  }
};
</script>
<style>
  .text-right{
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/devices/ModalDelete.vue